export default function UpdatesSection() {
  const updates = [
    { time: '2小时前', title: '《星辰恋语》第48话更新', tag: '恋爱', desc: '主角终于向暗恋对象告白，甜蜜又揪心的剧情迎来关键转折。' },
    { time: '4小时前', title: '《剑域风云》第132话上线', tag: '热血', desc: '剑域争霸赛进入最终决赛阶段，两大高手巅峰对决一触即发。' },
    { time: '6小时前', title: '《暗夜追逐》第67话发布', tag: '悬疑', desc: '新的嫌疑人浮出水面，隐藏多年的秘密终于开始被层层揭开。' },
    { time: '昨天', title: '《千秋岁》全120话完结纪念', tag: '古风', desc: '连载三年的古风巨作迎来圆满结局，万千读者为之动容。' },
    { time: '昨天', title: '《蜜糖陷阱》全86话完结撒花', tag: '恋爱', desc: '高甜恋爱漫画终章发布，男女主角修成正果，漫迷纷纷留言祝福。' },
    { time: '2天前', title: '《异能觉醒》第95话更新', tag: '奇幻', desc: '主角能力二次觉醒，全新篇章开启，世界观进一步展开。' },
    { time: '2天前', title: '新作《花间辞》第1话首发上线', tag: '古风', desc: '国风漫画家新锐力作，精湛的水墨画风带来不一样的视觉盛宴。' },
    { time: '3天前', title: '韩漫《星光咖啡馆》第28话更新', tag: '韩漫', desc: '温馨治愈的咖啡日常继续，新角色登场带来意想不到的剧情发展。' },
    { time: '3天前', title: '日漫《幻境迷途》第56话翻译完成', tag: '日漫', desc: '幻境世界的秘密逐渐浮出水面，主角团踏上最终决战之路。' },
  ];

  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">最近更新</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            实时追踪漫画更新动态，不错过任何一部心仪作品的最新章节
          </p>
        </div>

        <div className="max-w-3xl mx-auto relative">
          <div className="absolute left-5 md:left-7 top-0 bottom-0 w-px bg-background-300/60"></div>

          <div className="space-y-6">
            {updates.map((item, i) => (
              <div key={i} className="relative pl-12 md:pl-16">
                <div className="absolute left-3 md:left-5 top-1 w-3 h-3 md:w-4 md:h-4 rounded-full bg-primary-500 border-2 border-background-50"></div>
                <div className="bg-background-50 border border-background-200/70 rounded-xl p-4 md:p-5 hover:border-primary-200 transition-colors cursor-pointer">
                  <div className="flex items-center gap-2 mb-2 flex-wrap">
                    <span className="text-xs text-foreground-400">{item.time}</span>
                    <span className="px-2 py-0.5 rounded-md bg-accent-100 text-[10px] font-medium text-accent-700">{item.tag}</span>
                  </div>
                  <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-950 mb-1">{item.title}</h3>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center mt-8">
          <a href="#cards" className="inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 transition-colors cursor-pointer">
            查看更多更新
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}